import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function isYoutubeLinkValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtu\.be\/|youtube\.com\/(embed\/|v\/|watch\?v=))([\w-]{11})(?:[?&\w=]*)?$/;    
    const isYoutubeLink = youtubeRegex.test(control.value);
    return isYoutubeLink ? null : { link: { value: control.value } };
  };
}